import { useQuery } from '@tanstack/react-query'
import { fetchMe } from '@/lib/api'

/** One status line reused on Home, Plans, Devices. */
export function SubStatus() {
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: fetchMe })
  const active = !!me?.is_active && !!me?.expires_at
  const until = me?.expires_at ? new Date(me.expires_at).toLocaleDateString('ru-RU') : '—'
  const days = me?.days_left ?? 0
  const used = me?.devices_used ?? 0
  const limit = me?.device_limit ?? 3
  return (
    <div className="num text-[11px] tracking-[0.14em] uppercase flex flex-wrap items-center gap-x-2 gap-y-1"
      style={{ color: 'var(--color-muted)' }}>
      <span style={{ color: 'var(--color-ink)' }}>{used} / {limit} устройств</span>
      <span style={{ opacity: 0.4 }}>·</span>
      {active
        ? <span>подписка до {until} · {days} дн</span>
        : <span style={{ color: 'var(--color-accent)' }}>нет активной подписки</span>}
    </div>
  )
}
